import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatRadioButton, MatRadioGroup } from '@angular/material/radio';
import { NgxSkeletonLoaderComponent } from 'ngx-skeleton-loader';
import { SvgComponent } from 'icon';
import { ModalComponent } from 'modal';
import { Product } from 'product-shared';
import { Promotion } from 'promotion-shared';
import { ButtonComponent } from 'sakura-ui';
import { TranslatePipe } from 'translate';
import { ProductBoxPricingComponent } from '../product-box-pricing/product-box-pricing.component';

export interface ProductBoxPromotionSelectorModalData {
  modalTitle: string;
  product: Product;
  currentPromotion: Promotion;
  chipsLabelsKeys: string[];
}

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ReactiveFormsModule,
    ModalComponent,
    NgxSkeletonLoaderComponent,
    ProductBoxPricingComponent,
    MatRadioGroup,
    MatRadioButton,
    ButtonComponent,
    TranslatePipe,
    SvgComponent,
  ],
  templateUrl: './product-box-promotion-selector-modal.component.html',
})
export class ProductBoxPromotionSelectorModalComponent {
  private dialogRef = inject(MatDialogRef<ProductBoxPromotionSelectorModalComponent>);
  public data = inject<ProductBoxPromotionSelectorModalData>(MAT_DIALOG_DATA);
  public control = new FormControl<Promotion['id']>(null);
  public loading = signal(true);
  public promotions = signal<Promotion[]>([]);
  private selectedOption = toSignal(this.control.valueChanges);
  public optionSelected = computed(() => !!this.selectedOption());

  public setPromotions(promotions: Promotion[]) {
    this.promotions.set(promotions);

    const currentPromotion = promotions?.find(promo => promo.id === this.data.currentPromotion?.id);
    if (currentPromotion) {
      this.control.setValue(currentPromotion.id);
    }

    this.loading.set(false);
  }

  public onCancelClick() {
    this.dialogRef.close();
  }

  public onSubmitClick() {
    this.dialogRef.close(this.selectedOption());
  }
}
